module.exports = __webpack_public_path__ + "static/media/cookie-bite.9ffe60de.svg";